import { BaseComponent } from "react-vextensions";
import { VReactMarkdown, PageContainer } from "vwebapp-framework";
let red = `rgba(255,0,0,.7)`;
let green = `rgba(0,255,0,.6)`;
let pageText = `
[Home page text not yet added.]
`;
export class HomeUI2 extends BaseComponent {
    render() {
        return (React.createElement(PageContainer, { scrollable: true },
            React.createElement("article", null,
                React.createElement(VReactMarkdown, { source: pageText, className: 'selectable', escapeHtml: false }))));
    }
}
